import React from 'react'

interface ContextState {
  openQuiz: (gameId: string) => void,
  closeQuiz: (gameId: string) => void,
  isQuizOpenedByUser: (gameId: string) => boolean,
  isQuizClosedByUser: (gameId: string) => boolean,
}

interface ProviderState {
  [gameId: string]: boolean
}

type Action =
  | { type: 'open', gameId: string }
  | { type: 'close', gameId: string }

const initialContextState: ContextState = {
  openQuiz: (gameId: string) => { return },
  closeQuiz: (gameId: string) => { return },
  isQuizOpenedByUser: (gameId: string) => false,
  isQuizClosedByUser: (gameId: string) => false,
}

const initialProviderState: ProviderState = {}

const reducer: React.Reducer<ProviderState, Action> = (state, action) => {
  switch (action.type) {
    case 'open':
      return { ...state, [action.gameId]: true }
    case 'close':
      return { ...state, [action.gameId]: false }
    default:
      throw new Error(`Invalid QuizToggleContext reducer action (${action})!`)
  }
}

export const QuizToggleContext = React.createContext<ContextState>(initialContextState)

export const QuizToggleProvider: React.SFC = ({ children }) => {
  const [ state, dispatch ] = React.useReducer(reducer, initialProviderState)

  return (
    <QuizToggleContext.Provider
      value={{
        openQuiz: (gameId: string) => { dispatch({ type: 'open', gameId }) },
        closeQuiz: (gameId: string) => { dispatch({ type: 'close', gameId }) },
        isQuizClosedByUser: (gameId: string) => state[gameId] === false,
        isQuizOpenedByUser: (gameId: string) => state[gameId] === true,
      }}
    >
      {children}
    </QuizToggleContext.Provider>
  )
}
